import { Check, FiberManualRecord as Circle } from '@mui/icons-material';
import { Skeleton, styled } from '@mui/material';

const IconContainer = styled('div')(({ theme }) => ({
  color: theme.palette.background.paper,
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '50%',
  padding: theme.spacing(0.25),
  border: `2px solid ${theme.palette.divider}`,
  cursor: 'pointer',

  '&.active': {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
  '&.completed': {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
}));

const IconCheck = styled(Check)(({ theme }) => ({
  color: 'white',
  zIndex: 1,
  fontSize: theme.spacing(2.5),
}));

const IconCircle = styled(Circle)(({ theme }) => ({
  zIndex: 1,
  fontSize: theme.spacing(2.5),
}));

const IconSkeleton = styled(Skeleton)(({ theme }) => ({
  borderRadius: '50%',
  width: theme.spacing(3),
  height: theme.spacing(3),
}));

export { IconContainer, IconCheck, IconCircle, IconSkeleton };
